import type { CalculatorDef } from './types';
import { dilutionCalculator } from './dilution';
import { blendCalculator } from './blend';
import { tempCorrectionCalculator } from './tempCorrection';
import { absoluteAlcoholCalculator } from './absoluteAlcohol';
import { sugarYieldCalculator } from './sugarYield';

/**
 * Every calculator on the site, in the order they appear.
 *
 * Registering here is all it takes to publish one: the page generator reads this list to
 * build the calculators pages in both languages, and the generic form renderer builds the
 * UI from `fields` and `outputs`. There is no per-calculator markup to write.
 *
 * A new calculator does need its strings in **both** `src/lib/i18n/hu.json` and `en.json`
 * — `npm test` fails if either is missing.
 */
export const calculators: readonly CalculatorDef[] = [
  dilutionCalculator,
  blendCalculator,
  tempCorrectionCalculator,
  absoluteAlcoholCalculator,
  sugarYieldCalculator,
];

export const calculatorsById: ReadonlyMap<string, CalculatorDef> = new Map(
  calculators.map((c) => [c.id, c]),
);

export * from './types';
export { dilute } from './dilution';
export { blend } from './blend';
export { correctForTemperature } from './tempCorrection';
export { absoluteAlcohol } from './absoluteAlcohol';
export { sugarYield } from './sugarYield';
